module.exports = __webpack_public_path__ + "img/123.2e165511.webp";